export const environment = {
  production: true,
  environment: 'Production',
  configFile: 'assets/config/config.prod.json'
};
